import { Box, Typography } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import EmployeeList from "./employeeList";
import EventInfo from "./eventInfo";

function ViewDetails({ id, eventList }) {

    console.log('dataList', eventList);

    return (
        <Box
            sx={{
                width: "100%",
                px: { xs: 2 }, // padding for mobile and desktop
                py: { xs: 1 },        // vertical padding for mobile and desktop
            }}
        >
            {/* <BasicBreadcrumbs first="Mission Info" /> */}
            <EventInfo data={eventList} id={id}/>
            <Box>
            </Box>
            <EmployeeList id={id} />
        </Box>
    );
}

export default ViewDetails;